export type BrandKey = 'wuhenai'

export type BrandConfig = {
  key: BrandKey
  productName: string
  slogan: string
  logoPath: string
  faviconPath: string
  ogImagePath: string
  workbenchName: string
}

export const brandKey: BrandKey = 'wuhenai'

export const brand: BrandConfig = {
  key: 'wuhenai',
  productName: '无痕AI',
  slogan: '视频无痕消除效果No.1',
  logoPath: '/logo.png',
  faviconPath: '/favicon.ico',
  ogImagePath: '/og-image.png',
  workbenchName: '无痕AI',
}
